import { reatomAsync, withAbort } from "@reatom/async";
import { ExportTaskIdDto } from "definitions/exporter";
import { API } from "src/api";
import { toastHandler, truncateStart } from "src/util";

import { getExportTasksRequest } from "./getExportTaskRequest";

export const deleteExportTaskRequest = reatomAsync(
  async (ctx, data: ExportTaskIdDto) => {
    const response =
      await API.exporterQueueApi.exportControllerDeleteExportTask(data, {
        signal: ctx.controller.signal,
      });
    if (response.data) {
      toastHandler.success({
        name: "updateExportTasks",
        title: "Удаление выгрузки",
        content: `Выгрузка ${truncateStart(data.id)} удалена`,
      });
    }
  },
  {
    name: "deleteExportTaskRequest",
    onFulfill: (ctx) => getExportTasksRequest(ctx),
  },
).pipe(withAbort());
